/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `Deal` - DEAL
 * `Inspection` - INSPECTION
 * `Load` - LOAD
 * `PurchaseOrder` - PURCHASE_ORDER
 * `SalesOrder` - SALES_ORDER
 * `Shipment` - SHIPMENT
 * `TradeCompany` - TRADE_COMPANY
 */
export type ContextModelNameEnum = (typeof ContextModelNameEnum)[keyof typeof ContextModelNameEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContextModelNameEnum = {
  Deal: 'Deal',
  Inspection: 'Inspection',
  Load: 'Load',
  PurchaseOrder: 'PurchaseOrder',
  SalesOrder: 'SalesOrder',
  Shipment: 'Shipment',
  TradeCompany: 'TradeCompany',
} as const;
